var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3197 27.8794H14.6798L14.6798 17.3199L4.12036 17.3199L4.12036 14.6801L14.6798 14.6801L14.6798 4.12059H17.3197L17.3197 14.6801L27.8792 14.6801L27.8792 17.3199L17.3197 17.3199L17.3197 27.8794Z",
    fill: "#666666"
  })));
};
export default SvgAdd;